import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductLogisticGroup } from '../../entities/control-tables/product-logistic-group';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class ProductLogisticGroupRequest extends BaseRequest {

    productLogisticGroup : ProductLogisticGroup

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.productLogisticGroup = new ProductLogisticGroup()
  }
}